import { Section, eType, SectionInitData } from "../Section";
import { GameWorld, eGameObject as eWorldObject } from "../../GameWorld";
import { ParcelManager } from "../../../Parcel/ParcelManager";



/**
 * Stredova cast s vydejnou baliku
 */
export class ParcelCollection_2 extends Section {
    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        super("collection_2", eType.parcelCollection_2, false);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    activate(z: number, initData?: SectionInitData): Section {
        super.activate(z, initData);

        // Vytvorit odberne misto
        ParcelManager.instance.addDispenser(z + this._size / 2 - 0.36, 1);

        return this;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    protected addObjectEntities(): void {
        let world = GameWorld.instance;

        // Zem
        let e = world.getObjectNewEntity(eWorldObject.ground_0);
        e.setEulerAngles(0, 0, 0);
        e.setLocalPosition(0, 0, 0);
        e.reparent(this._root);

        // Vydejna balicku
        e = world.getObjectNewEntity(eWorldObject.parcelCollection);
        e.setLocalPosition(-1.5, 0, -0.36);
        e.setEulerAngles(0, 0, 0);
        e.reparent(this._root);

        e = world.getObjectNewEntity(eWorldObject.parcelCollectionCarousel);
        e.reparent(this._root);
        e.setLocalPosition(-1, 0, -0.36);

        // Krabice
        e = world.getObjectNewEntity(eWorldObject.box);
        e.setEulerAngles(0, 0, 0);
        e.setLocalPosition(0.85, 0.035, -0.75);
        e.reparent(this._root);

        e = world.getObjectNewEntity(eWorldObject.box);
        e.setEulerAngles(0, 0, 0);
        e.setLocalPosition(1.25, 0.035, -0.75);
        e.reparent(this._root);

        // Paleta
        e = world.getObjectNewEntity(eWorldObject.pallet);
        e.setEulerAngles(0, 0, 0);
        e.setLocalPosition(1.05, 0.1, -0.285);
        e.reparent(this._root);

        // Strom
        e = world.getObjectNewEntity(eWorldObject.tree);
        e.setLocalPosition(1.1, 0.04, 0.5);
        e.setLocalScale(1, 1, 1);
        e.reparent(this._root);

        // Zed
        e = world.getObjectNewEntity(eWorldObject.wall);
        e.setLocalPosition(0, 0, 1.29);
        e.reparent(this._root);
    }
}